import { createAction } from 'Lib/reduxUtils';

import { LOAD_PHOTO, LOAD_PHOTO_SUCCESS, VERIFY_ROUTE, VERIFY_ROUTE_SUCCESS } from './constants';

export const verifyRoute = createAction(VERIFY_ROUTE);
export const verifyRouteSuccess = createAction(VERIFY_ROUTE_SUCCESS);
export const setPhotoEditorLoading = createAction(LOAD_PHOTO);
export const setPhotoEditorLoadingSuccess = createAction(LOAD_PHOTO_SUCCESS);
